import { useEffect, useState } from 'react';
import { subscribeImagePreview } from '../utils/events/imagePreview';

export function useDocumentPreview(userDocuments = []) {
  const [activeImageIdx, setImageIdx] = useState(null);
  const images = userDocuments.map(({ attachment: { url } }) => ({ src: url }));

  useEffect(() => subscribeImagePreview(setActiveIndex), [userDocuments]);

  function setActiveIndex(activeUrl) {
    const index = userDocuments.findIndex(
      ({ attachment: { thumbMiddle } }) => activeUrl === thumbMiddle,
    );

    if (index !== -1) {
      setImageIdx(index);
    }
  }

  function resetImageIdx() {
    setImageIdx(null);
  }

  function nextImage() {
    setImageIdx(activeImageIdx + 1);
  }

  function prevImage() {
    setImageIdx(activeImageIdx - 1);
  }

  return {
    images,
    activeImageIdx,
    resetImageIdx,
    nextImage,
    prevImage,
  };
}



// WEBPACK FOOTER //
// ./src/hooks/useDocumentPreview.js